import { render, staticRenderFns } from "./textarea-ckeditor.vue?vue&type=template&id=d61758c2&"
import script from "./textarea-ckeditor.vue?vue&type=script&lang=js&"
export * from "./textarea-ckeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports